/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

// import { getScaledValue } from 'renative';

import Icons from './../../../assets/icons';
import { getScaledValue } from '../../../ui/styled';

export const SideOption = styled.TouchableHighlight.attrs(
  (props: { active?: boolean; first?: string; last?: string; theme: { primary: string } }) => ({
    underlayColor: props.theme.primary,
  }),
)`
  width: ${getScaledValue(26)}px;
  height: ${getScaledValue(26)}px;
  border-radius: ${getScaledValue(13)}px;
  background: #000000;
  align-items: center;
  justify-content: center;

  ${(props: { active?: boolean; first?: string; last?: string; theme: { primary: string } }) =>
    props.active
      ? `
            width: ${getScaledValue(42)}px;
            height: ${getScaledValue(42)}px; 
            background: ${props.theme.primary};
            border-radius: ${getScaledValue(21)}px; 
            border-width: ${getScaledValue(4)}px; 
            border-color: ${(props: { active?: boolean; first?: string; last?: string; theme: { primary: string } }) => props.theme.primary};  
            ${
              props.first || props.last
                ? `
                    ${
                      props.first
                        ? `
                            margin: -${getScaledValue(8)}px 0 -${getScaledValue(4)}px;
                        `
                        : ``
                    } 
                    ${
                      props.last
                        ? `
                            margin: -${getScaledValue(4)}px 0 -${getScaledValue(8)}px;
                        `
                        : ``
                    } 
                `
                : `
                    margin: -${getScaledValue(4)}px 0; 
                `
            } 


        `
      : ``}
  ${(props: { active?: boolean; first?: string; last?: string; theme: { primary: string } }) =>
    props.first
      ? ``
      : `
            margin-top: ${getScaledValue(0)}px; 
        `}
`;

export const SideOptionIcon = styled(Icons).attrs(
  (props: { active?: boolean; first?: string; last?: string; theme: { primary: string } }) => ({
    width: props.active ? getScaledValue(16) : getScaledValue(12),
    height: props.active ? getScaledValue(16) : getScaledValue(12),
  }),
)``;
